import _isNil from 'lodash/isNil';
import { SettingsType } from '@Components/Settings/SettingsType';

const AuthorizationModel = {
    canViewSettingsButton: (
        settingsType: SettingsType,
        relationship: Array<string>
    ): boolean => {
        if (_isNil(relationship)) return false;

        let allowedRelationships: string[];
        switch (settingsType) {
            case SettingsType.PROFILE:
                return true;
            case SettingsType.TEAMSADMIN:
                allowedRelationships = ['parent', 'owner', 'teamleader'];
                break;
            case SettingsType.ORGADMIN:
                allowedRelationships = ['owner', 'parent', 'admin'];
                break;
            case SettingsType.SUPERADMIN:
                return false;
        }

        const intersection = allowedRelationships.filter((r) =>
            relationship.includes(r)
        );
        return intersection.length > 0;
    },
};

export default AuthorizationModel;
